import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import Overlay from "../../Overlay";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import CreateNewRequest from "./Tabs/CreateNewRequest";
import RequestHistory from "./Tabs/RequestHistory";
import { getMyHelpRequests } from "../Store/Thunk";
import ScrollableCard from "../../ScrollableCard";

export default function HelpDesk() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.helpDesk.isLoading);
  const myHelpRequests = useSelector((state) => state.helpDesk.myHelpRequests);

  const [currentTab, setCurrentTab] = useState("createNewRequest");

  useEffect(() => {
    dispatch(getMyHelpRequests());

  }, []);

  return (
    <div>
      {isLoading && <Overlay />}

      <Row
        className={"tab-container-single-line text-20 text-color-gray-light fw-semibold"}
        style={{ height: "40px", margin: "0 12px 0px 12px" }}
      >
        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${currentTab === "createNewRequest" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setCurrentTab("createNewRequest");
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              {t("createNewRequest")}
            </Col>
          </Row>
        </Col>

        <Col className={"align-content-center"}>
          <Row
            className={`tab-button justify-content-center h-100  ${currentTab === "requestHistory" && "selected"}`}
            style={{ height: "30px" }}
            onClick={() => {
              setCurrentTab("requestHistory");
            }}
          >
            <Col xs={"auto"} className={"align-content-center"}>
              {t("requestHistory")}
            </Col>
          </Row>
        </Col>
      </Row>
      <ScrollableCard>
        <Row className={"mx-0 "}>
          <Col>
            {currentTab === "createNewRequest" && <CreateNewRequest />}
            {currentTab === "requestHistory" && <RequestHistory myHelpRequests={myHelpRequests} />}
          </Col>
        </Row>
      </ScrollableCard>
    </div>
  );
}
